export const isOdoEmail = (email: string | undefined): boolean => {
    if (!email) return false;
    return email.toLowerCase().endsWith('@ondemandorthodontist.com');
};

export const isAiEmail = (email: string | undefined): boolean => {
    if (!email) return false;
    return email.toLowerCase() === 'do-not-reply@ondemandorthodontist.com';
};

// The ODO automations and auto-reply sender; the server refuses its messages to everyone.
const SYSTEM_SENDER_EMAIL = 'notifications@ondemandorthodontist.com';

const isOdoStaffEmail = (email: string | undefined): boolean =>
    isOdoEmail(email) && !isAiEmail(email) && email?.toLowerCase() !== SYSTEM_SENDER_EMAIL;

export const canManageMessage = (
    authorEmail: string | undefined,
    currentUserEmail: string | undefined,
    manageOdoStaffMessages: boolean
): boolean => {
    const isOwn =
        !!currentUserEmail && authorEmail?.toLowerCase() === currentUserEmail.toLowerCase();
    if (isOwn) return true;
    return manageOdoStaffMessages && isOdoStaffEmail(authorEmail);
};
